import React from 'react';
import { useEffect, useState, useRef } from 'react';
import style from './ContactUs.module.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { GoogleMap, Marker, LoadScript } from '@react-google-maps/api';
import '../../components/headersStyling.css';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { getcontactusSettings, sendContactMsg } from './../../Api/contactusApis';
import { basename, map_key, recaptcha_key, recaptcha_secretKey } from './../../configiration/config';
import { getWebsiteSettings } from '../../Api/commonApis';
import { filterLanguage } from '../../utilities/filterFunction';
import noImage from '../../assets/images/noImage.png';
import Recaptcha from 'react-google-recaptcha';
import { imgResize } from './../../utilities/imageResize';

function ContactUs() {
    const { t } = useTranslation();
    let refRecaptcha=useRef();
    let navigate = useNavigate();
    const [contactData, setContactdata] = useState({'g-recaptcha-response':''});
    const [emailData,setemailData] = useState();
    const [phoneData,setphoneData] = useState();
    const [locationData,setlocationData] = useState();
    const [helpData,sethelpData] = useState();
    const [errors, setErrors] = useState({ name: '', email: '', message: '' });
    const { pathname } = useLocation();
    const [libraries] = useState(['places']);
    const [location, setLocation] = useState({ lat: '', lng: '' });
    const [loading, setLoading] = useState(false);
    const [contactusData, setcontactusData] = useState({});
    const [websiteSettings, setwebsiteSettings] = useState({});

    // Scroll top on load
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    // get contact us
    useEffect(() => {
        getcontactusSettings().then((res) => {
            let contact = { ...contactusData }
             contact= res.data.data
            setemailData(filterLanguage(contact.contact_us_feel_free && contact.contact_us_feel_free.locales))
            setphoneData(filterLanguage(contact.contact_us_call_us && contact.contact_us_call_us.locales))
            setlocationData(filterLanguage(contact.contact_us_visit_us && contact.contact_us_visit_us.locales))
            sethelpData(filterLanguage(contact.contact_us_how_can_we_help && contact.contact_us_how_can_we_help.locales))
            setcontactusData(contact);
        })
        // to get latitude and lang
         getWebsiteSettings().then((res) => {
            let settings = { ...websiteSettings }
            settings = res.data.data
            setwebsiteSettings(settings);
        })
        // eslint-disable-next-line
    }, []);

    // set map location
    useEffect(() => {
        let loc = { ...location }
        loc = {
            lat: Number(websiteSettings !==null && websiteSettings.latitude), lng: Number(websiteSettings !==null && websiteSettings.longitude)
        }
        setLocation(loc);
        // eslint-disable-next-line
    }, [websiteSettings]);

    // eslint-disable-next-line
    const [map, setMap] = useState(null);

    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, []);

    const containerStyle = {
        width: "100%",
        height: '300px'
    };

    // inputs onchange handler
    function contactInputsHandler(e) {
        let contact = { ...contactData };
        contact[e.target.name] = e.target.value;
        setContactdata(contact);
        let err = { ...errors }
        err[e.target.name] = '';
        setErrors(err);
    }
    // on form submit handler
    async function submitContactHandler( e) {
        e.preventDefault();
        setLoading(true);
        let token= await refRecaptcha.current.executeAsync()
        let data= {...contactData}
        data['g-recaptcha-response']=token
        sendContactMsg(data).then(() => {
            Swal.fire({
                icon: 'success',
                text: "Message sent successfully!"
            }).then(() => {
                document.getElementById('contactForm').reset();
                for (const key in contactData) {
                    contactData[key]=''
                }
            }
            )
            setLoading(false);
        }).catch((error) => {
            refRecaptcha.current.reset()
            setLoading(false);
            let err = { ...errors }
            for (const key in err) {
                if (error.response.data.data[key]) {
                    err = { ...err, [key]: error.response.data.data[key] };
                    setErrors(err);
                }
            }
        })
    }


    return (
        <div>
            {/* START OF HEADER SECTION */}
            {contactusData !== null && contactusData.image ?
                <div className={`myHeader d-flex align-items-center justify-content-center`} style={{ backgroundImage: `url(${imgResize(contactusData.image,1920,0)})` }} onError={(e) =>e.target.src={noImage}}>
                    <div className={`myHeaderContent`}>
                        <h1>{t('contact-us')}</h1>
                        <p><span className='homeWord' onClick={() => { navigate(`${basename}/`) }}>{t('home')}</span> / {t('contact-us')}</p>
                    </div>
                </div>
                :
                <div className={`myHeader d-flex align-items-center justify-content-center`}>
                <div className={`myHeaderContent`}>
                    <h1>{t('contact-us')}</h1>
                    <p><span className='homeWord' onClick={() => { navigate(`${basename}/`) }}>{t('home')}</span> / {t('contact-us')}</p>
                </div>
            </div>
            }
            {/* END OF HEADER SECTION */}
            <div className="smallcomponentContainer">
                <div className={`${style.myCustomContainer}`}>
                    {/* START OF CONTACT INFO SECTION */}
                        <div className={`${style.contactInfo} row `}>
                            <div className={`${style.LHS} col-md-6 mb-3`}>
                            {emailData && emailData.length > 0 &&
                                <div>
                                    <h5 className={`${style.titleh5} d-flex justify-content-start align-items-center flex-wrap`}>
                                        {emailData[0].title !== null && emailData[0].title}
                                        {websiteSettings && <a href={`mailto:${websiteSettings.email}`} className={style.contactEmailLink}> {websiteSettings.email} </a>}
                                    </h5>
                                    <p>{emailData[0].description !== null && emailData[0].description}</p>
                                </div>
                                }
                              {phoneData && phoneData.length > 0 &&
                                <div>
                                    <h5 className={`${style.titleh5}  d-flex justify-content-start align-items-center`}>{phoneData[0].title !== null && phoneData[0].title}  
                                        {websiteSettings && <a href={`tel:${websiteSettings.phone}`} className={style.contactPhoneLink}> +{websiteSettings.phone} </a>}
                                    </h5>
                                    <p>{phoneData[0].description !== null && phoneData[0].description}</p>
                                </div>
                                }
                                <div>
                                {locationData && locationData.length > 0 &&
                                <>
                                    <h5 className={`${style.titleh5}`}>{locationData[0].title !== null && locationData[0].title}</h5>
                                    <p>{locationData[0].description !== null && locationData[0].description}</p>
                                </>
                                }
                                   {location && location.lat ? 
                                   <div>
                                        <LoadScript id="script-loader" googleMapsApiKey={map_key}
                                            libraries={libraries}>
                                            <GoogleMap mapContainerStyle={containerStyle} center={location} zoom={20} onUnmount={onUnmount} draggable={false}>
                                                <Marker position={location} draggable={false} />
                                            </GoogleMap>
                                        </LoadScript>
                                    </div>:<div></div>}
                                </div>
                            </div>
                            <form className={`${style.formInputs}  col-md-6 d-flex flex-column mb-3 `} id='contactForm' onSubmit={submitContactHandler}>
                            {helpData && helpData.length > 0 &&
                                <div className={style.formTitleDes}>
                                    <h5 className={`${style.titleh5}`}>{helpData[0].title !== null && helpData[0].title}</h5>
                                    <p className='mb-0'>{helpData[0].description !== null && helpData[0].description}</p>
                                </div>
                                }
                                <div>
                                    <div className={`${style.inputsGroupContactUs}`}>
                                        <label htmlFor="exampleFormControlInput1" className={`form-label ${style.contactUsLabels}`}>
                                            {t('first-name')}
                                        </label>
                                        <input type="name" name='name' className={`form-control ${style.contactUsInputs}`} onChange={contactInputsHandler} id="exampleFormControlInput1" required />
                                    </div>
                                    <div className='text-danger'>{errors.name}</div>
                                    <div className={`${style.inputsGroupContactUs}`}>
                                        <label htmlFor="exampleFormControlInput1" className={`form-label ${style.contactUsLabels}`}>{t('email-address')}</label>
                                        <input type="email" name='email' className={`form-control ${style.contactUsInputs}`} onChange={contactInputsHandler} id="exampleFormControlInput1" required />
                                    </div>
                                    <div className='text-danger'>{errors.email}</div>
                                    <div className={`${style.inputsGroupContactUs}`}>
                                        <label htmlFor="exampleFormControlTextarea1" className={`form-label ${style.contactUsLabels}`}>{t('write-message')}</label>
                                        <textarea className={`form-control ${style.contactUstextArea}`} name='message' onChange={contactInputsHandler} id="exampleFormControlTextarea1" rows="8" required></textarea>
                                    </div>
                                    <div className='text-danger'>{errors.message}</div>
                                </div>
                                <Recaptcha
                                    ref={refRecaptcha}  
                                    sitekey={recaptcha_key} 
                                    secretkey={recaptcha_secretKey}
                                    size={'invisible'}
                                />
                                {loading ?
                                 <div className={`${style.submitBtn}`}>
                                    <button  type='submit' disabled className='d-flex'>
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        <span className='mx-2'>{t('sending')}...</span> 
                                    </button>
                                </div>
                                    : <div className={`${style.submitBtn}`}>
                                        <button  type='submit'>{t('send')}</button>
                                    </div>
                                }


                            </form>
                        </div>
                    {/* END OF CONTACT INFO SECTION */}
                </div>
            </div>
        </div>
    )
}

export default ContactUs